<router-outlet>
    <p-toast></p-toast>
</router-outlet>
